import {
  CONSUMER_CMS_SHOPPING_CART,
  IPersonalInfoCMS,
  useCmsConfig,
} from '@vfit/consumer/data-access';
import { API, getClickToCallWithKeyOrUrl, trackLink } from '@vfit/shared/data-access';
import { ConfirmIdentity } from '@vfit/shared/components';
import { IFindCallerObject } from '@vfit/shared/models';
import { organizeConfirmIdentityCard } from './coverageToolChooseContact.utils';
import { useCoverageToolModalProvider } from '../../coverageToolModal.context';
import { organizeCoverageToolCheckNumberCard } from '../CoverageToolCheckNumberCard/coverageToolCheckNumberCard.utils';
import { ICommonData } from '../../../StepperStateCards/stepperStateCards.models';
import { ButtonWrapper } from './coverageToolChooseContact.style';
import CoverageToolChooseContactTagging from './coverageToolChooseContact.tagging';
import { ButtonCBU } from '@vfit/consumer/components';
import { useQueryClient } from 'react-query';

const CoverageToolChooseContact = ({ handleGoNextSlide }: ICommonData) => {
  const { findCaller, setFindCaller, product } = useCoverageToolModalProvider();
  const client = useQueryClient();
  const dataFromCms = useCmsConfig(
    CONSUMER_CMS_SHOPPING_CART,
    API.CMS_GET_PERSONAL_DATA
  ) as IPersonalInfoCMS;

  const handleSelect = (selectedItem: { field: string; fieldType: 'msisdn' | 'email' }) => {
    setFindCaller({
      ...(findCaller as IFindCallerObject),
      selectedContactMedium: selectedItem.field?.trim() ? selectedItem : undefined,
    });
  };

  const { descriptionCms, placeholderCms, titleCms, ctaLabelCms, ctaUrl } =
    organizeConfirmIdentityCard(dataFromCms, product);

  const { checkNumberProps } = organizeCoverageToolCheckNumberCard(dataFromCms);

  const cardConfig = {
    getSelectedData: handleSelect,
    identityTypeItems: [
      (findCaller as IFindCallerObject)?.individualRef?.email || '',
      (findCaller as IFindCallerObject)?.individualRef?.msisdn || '',
    ],
    title: titleCms,
    description: descriptionCms,
    placeholder: placeholderCms,
    cta: {
      label: ctaLabelCms,
      url: ctaUrl,
      action: () => {
        if (product?.urlClickToCallOtp) {
          trackLink(`verify id:${ctaLabelCms?.toLowerCase()}`);
          getClickToCallWithKeyOrUrl(client, product?.urlClickToCallOtp, product);
        } else if (ctaUrl) {
          trackLink(`verify id:${ctaLabelCms?.toLowerCase()}`);
          window.location.href = ctaUrl;
        } else {
          null;
        }
      },
    },
  };

  const onSubmit = () => {
    if (handleGoNextSlide && (findCaller as IFindCallerObject)?.selectedContactMedium) {
      handleGoNextSlide();
    }
  };

  return (
    <>
      <CoverageToolChooseContactTagging />
      <ConfirmIdentity data={cardConfig} />
      <ButtonWrapper>
        <ButtonCBU
          disabled={false}
          onClick={onSubmit}
          variant={'primary'}
          name="action_checkNumber"
        >
          {checkNumberProps?.ctaLabel || 'Prosegui'}
        </ButtonCBU>
      </ButtonWrapper>
    </>
  );
};

export default CoverageToolChooseContact;

